var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCognacIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.879 93.8642C129.918 104.502 127.228 111.556 126.463 113.347C126.333 113.651 126.215 113.955 126.121 114.273L113.445 157.199C112.692 159.75 110.35 161.5 107.691 161.5H69.1882C66.5289 161.5 64.1869 159.75 63.4338 157.199L50.7582 114.273C50.6644 113.955 50.5465 113.651 50.4164 113.347C49.6508 111.556 46.9616 104.502 47.0004 93.8642C47.0392 81.4635 68.7405 71.601 73.0549 68.4297C76.9538 65.5683 77.5765 60.6664 77.6609 59.7361C77.6704 59.632 77.6729 59.529 77.6729 59.4244V24C77.6729 20.6863 80.3592 18 83.6729 18H93.1998C96.5135 18 99.1998 20.6863 99.1998 24V59.421C99.1998 59.5278 99.2025 59.6328 99.2123 59.7392C99.2988 60.6771 99.9291 65.5714 103.818 68.4297C108.139 71.601 129.834 81.4635 129.879 93.8642Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2008 35.0957H77.6738",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2008 52.6514H77.6738",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4082 72.8408L85.7227 85.4135C87.7104 86.6436 90.2316 86.6074 92.1831 85.3207L111.11 72.8408",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.377 122.309H76.9297C73.616 122.309 70.9297 124.995 70.9297 128.309V134.057C70.9297 137.371 73.616 140.057 76.9297 140.057H102.377C105.691 140.057 108.377 137.371 108.377 134.057V128.309C108.377 124.995 105.691 122.309 102.377 122.309Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCognacIcon);
export default __webpack_public_path__ + "static/media/cognac-icon.c209692a86897ebb2d756513e0c9ed90.svg";
export { ForwardRef as ReactComponent };